import {
  Person as PersonIcon,
  ContactMail as ContactIcon,
  People as GuardianIcon,
  School as AcademicIcon,
  EventNote as AttendanceIcon,
  Psychology as BehavioralIcon,
  LocalHospital as HealthIcon,
  SupportAgent as SupportIcon,
  Badge as DemographicIcon,
  Task as TaskIcon
} from '@mui/icons-material';
import {
  BasicInfoSection,
  ContactInfoSection,
  GuardianSection,
  AcademicSection,
  AttendanceSection,
  BehavioralSection,
  HealthSection,
  SupportSection,
  DemographicSection,
  TasksSection
} from './sections';

export const tabs = [
  { icon: <PersonIcon />, label: 'Basic Info', component: BasicInfoSection },
  { icon: <ContactIcon />, label: 'Contact', component: ContactInfoSection },
  { icon: <GuardianIcon />, label: 'Guardians', component: GuardianSection },
  { icon: <AcademicIcon />, label: 'Academic', component: AcademicSection },
  { icon: <AttendanceIcon />, label: 'Attendance', component: AttendanceSection },
  { icon: <BehavioralIcon />, label: 'Behavioral', component: BehavioralSection },
  { icon: <HealthIcon />, label: 'Health', component: HealthSection },
  { icon: <SupportIcon />, label: 'Support', component: SupportSection },
  { icon: <DemographicIcon />, label: 'Demographics', component: DemographicSection },
  { icon: <TaskIcon />, label: 'Tasks', component: TasksSection }
];